import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { AuthNavigator } from './AuthNavigator';
import { ReceptionistNavigator } from './ReceptionistNavigator';
import { AdminNavigator } from './AdminNavigator';
import { UserRole } from '../types';

export const AppNavigator = () => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  return (
    <NavigationContainer>
      {!isAuthenticated || !user ? (
        <AuthNavigator />
      ) : String(user) === UserRole.MASTER_ADMIN ? (
        <AdminNavigator />
      ) : (
        <ReceptionistNavigator />
      )}
    </NavigationContainer>
  );
};
